export const gameSortMap = {
    '1001': 20,
    '1002': 22,
    '1005': 6,
    '1006': 11,
    '1007': 17,
    '1008': 27,
    '1009': 25,
    '1010': 28,
    '1011': 29,
    '1014': 10,
    '1015': 30,
    '1016': 31,
    '1017': 21,
    '1018': 32,
    '1019': 15,
    '1020': 26,
    '1021': 33,
    '2001': 0,
    '2002': 23,
    '2003': 1,
    '2004': 34,
    '2005': 9,
    '2006': 35,
    '2008': 5,
    '2009': 19,
    '2010': 8,
    '2011': 36,
    '2101': 12,
    '2102': 37,
    '3001': 2,
    '3002': 3,
    '3003': 38,
    '3004': 7,
    '3005': 39,
    '3006': 40,
    '4001': 4,
    '4002': 41,
    '4003': 42,
    '5001': 43,
    '5002': 18,
    '5003': 16,
    '5004': 14,
    '5005': 13,
    '6001': 44,
    '6002': 45,
    '6003': 46,
    '6004': 47,
    '6005': 48,
    '6006': 49,
    '6007': 50,
    '6008': 51,
    '6009': 52,
    '6010': 53,
    '6011': 54,
    '6012': 55,
    '6013': 56,
    '7005': 57,
    '8001': 58,
    '8002': 24,
    '8003': 59,
    '8004': 60,
    '8005': 61,
    '8006': 62,
    '9001': 63,
    '9031': 64,
    '9061': 65,
    '9062': 66,
    '9063': 67,
    '9064': 68,
    '9065': 69,
    '9066': 70,
    '9067': 71,
    '9068': 72,
    '9069': 73,
    '9070': 74,
    '9091': 75,
    '9092': 76,
    '9093': 77,
    '9094': 78,
    '9121': 79,
    '9151': 80,
    '9152': 81
}
export const tableSettingModel = {
    dataRecord: 'dataRecord',
    userList: 'userList',
    userPointRecord: 'userPointRecord',
    userSupport: 'userSupport',
    userRiskConf: 'userRiskConf',
    subGameData: 'subGameData',
    rechargeData: 'rechargeData'
}
